import { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';

const wrapperStyle = {
  overflow: 'hidden',
};

const permitNumAndEventsStyle = {
  flexWrap: 'wrap',
  marginLeft: '-padding_16',
  gap: 'padding_8',
};

const firstFlexElementStyle = {
  marginLeft: 'padding_16',
};

type Props = {
  activityPermitNumber: string | null;
  numberOfEvents: number;
};

const PermitNumAndNumberOfEvents = ({ activityPermitNumber, numberOfEvents }: Props) => {
  const numberOfEventsDisplay = useMemo(() => {
    return `${numberOfEvents} ${
      numberOfEvents === 1 ? 'status change' : 'status changes'
    }`;
  }, [numberOfEvents]);

  return (
    <Box sx={wrapperStyle}>
      <FlexRow sx={permitNumAndEventsStyle}>
        <Text.SmallLabel color={Colors.TextQuiet} sx={firstFlexElementStyle}>
          {activityPermitNumber}
        </Text.SmallLabel>
        <Text color={Colors.TextQuiet}>{`${numberOfEventsDisplay}`}</Text>
      </FlexRow>
    </Box>
  );
};

export default PermitNumAndNumberOfEvents;
